var exports = {
  "kL": "PiPOverlay.module__container___c0RkLV",
  "$I": "PiPOverlay.module__containerResizing___c0RkLV",
  "n_": "PiPOverlay.module__hoverOverlay___c0RkLV",
  "YQ": "PiPOverlay.module__containerInteractionActive___c0RkLV",
  "YL": "PiPOverlay.module__headerGradient___c0RkLV",
  "VW": "PiPOverlay.module__headerContent___c0RkLV",
  "LD": "PiPOverlay.module__headerLeft___c0RkLV",
  "q3": "PiPOverlay.module__returnToCallButton___c0RkLV",
  "fs": "PiPOverlay.module__returnToCallIcon___c0RkLV",
  "Qt": "PiPOverlay.module__returnToCallLabel___c0RkLV",
  "wY": "PiPOverlay.module__footerGradient___c0RkLV",
  "z8": "PiPOverlay.module__footerContent___c0RkLV",
  "PU": "PiPOverlay.module__footerLeft___c0RkLV",
  "zz": "PiPOverlay.module__streamerName___c0RkLV",
  "wV": "PiPOverlay.module__footerRight___c0RkLV",
  "ti": "PiPOverlay.module__spectatorBadge___c0RkLV",
  "Bh": "PiPOverlay.module__spectatorIcon___c0RkLV",
  "hP": "PiPOverlay.module__actionButton___c0RkLV",
  "P4": "PiPOverlay.module__disconnectButton___c0RkLV",
  "gE": "PiPOverlay.module__actionIcon___c0RkLV",
};

module.exports = exports;
